interface ISidebarSectionProps {
  title: string;
  children: any;
}

export const SidebarSection = ({ title, children }: ISidebarSectionProps) => {
  return (
    <div
      className="
      divide-y 
      [@media(min-height:783px)]:[@media(max-height:814px)]:my-1 
      [@media(min-height:815px)]:[@media(max-height:849px)]:my-2 
      [@media(min-height:850px)]:[@media(max-height:889px)]:my-3 
      [@media(min-height:890px)]:[@media(max-height:939px)]:my-4 
      [@media(min-height:940px)]:my-5"
    >
      <span className="text-gray-400 text-sm uppercase">{title}</span>
      <div className="py-1 xxl:mt-1"></div>
      {children}
    </div>
  );
};
